export const Shimmer = ({ className = "" }) => <div className={`shimmer rounded-2xl ${className}`} />;

export const PageFallback = ({ full }) => (
  <div className={`grid place-items-center ${full ? "min-h-[100dvh]" : "min-h-[50vh]"}`} data-testid="page-loader">
    <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-ts-blue-soft border-t-ts-blue" />
  </div>
);

export const GameGridSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-4 gap-x-3 gap-y-5 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8">
    {Array.from({ length: count }).map((_, i) => <div key={i} className="space-y-2"><Shimmer className="aspect-square" /><Shimmer className="mx-auto h-3 w-3/4 rounded" /></div>)}
  </div>
);

export const RowSkeleton = () => <Shimmer className="h-40" />;

export const ListSkeleton = ({ rows = 3 }) => (
  <div className="space-y-3">{Array.from({ length: rows }).map((_, i) => <Shimmer key={i} className="h-20" />)}</div>
);

export const TableSkeleton = ({ rows = 6 }) => (
  <div className="space-y-2 p-4">{Array.from({ length: rows }).map((_, i) => <Shimmer key={i} className="h-10 rounded-lg" />)}</div>
);
